/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import useFetch from "../hooks/useFetch";
import Confetti from 'react-confetti';
import styles from "../styles/encuesta.module.css";
import { useTranslation } from "react-i18next";
import Select from "react-select";
import Loader from "../components/Loader";

function Encuesta() {
    const [surveyToken, setSurveyToken] = useState(null);
    const [idEmpleado, setIdEmpleado] = useState(null);
    const [idEncuesta, setIdEncuesta] = useState(null);
    const [preguntas, setPreguntas] = useState([]);
    const [preguntasRespondidas, setPreguntasRespondidas] = useState([]); // Preguntas ya respondidas
    const [totalPreguntas, setTotalPreguntas] = useState(0);
    const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
    // eslint-disable-next-line no-unused-vars
    const [currentQuestionId, setCurrentQuestionId] = useState(null); // Guardar el id_pregunta actual (usado en refs)
    const [selectedOption, setSelectedOption] = useState(null);
    const [textResponse, setTextResponse] = useState('');
    const [encuestaCompletada, setEncuestaCompletada] = useState(false);
    const [showAviso, setShowAviso] = useState(true); 
    const [hideAviso, setHideAviso] = useState(false); 
    const location = useLocation();
    const { data, execute } = useFetch();
    const { execute: execute2 } = useFetch();
    const executeRef = useRef(execute);
    const executeRef2 = useRef(execute2);
    const currentQuestionIdRef = useRef(null);
    const currentQuestionIndexRef = useRef(0);
    const justSubmittedRef = useRef(false); // Ref para rastrear si acabamos de enviar una respuesta
    const [isSubmitting, setIsSubmitting] = useState(false);
    const { t, i18n } = useTranslation();
    const [estadoEncuesta, setEstadoEncuesta] = useState(null);
    const [ambienteTranquilo, setAmbienteTranquilo] = useState(false);
    const [aceptaPolitica, setAceptaPolitica] = useState(false);
    const [politicaAceptada, setPoliticaAceptada] = useState(false);
    const [loading, setLoading] = useState(true); // Estado para saber si estamos cargando
    const [showQuestionAlreadyAnswered, setShowQuestionAlreadyAnswered] = useState(false); // Estado para mostrar mensaje de pregunta ya respondida
    const [isMobile, setIsMobile] = useState(false);
    const [questionHistory, setQuestionHistory] = useState([]); // Historial de preguntas vistas/respondidas
    const isNavigatingBackRef = useRef(false); // Ref para indicar si estamos retrocediendo
    const questionHistoryRef = useRef([]); // Ref para acceder al historial más reciente
    const [managerInfo, setManagerInfo] = useState(null); // Información del manager
    const [surveyWelcomeInfo, setSurveyWelcomeInfo] = useState({ nombreEquipo: null, nombreLider: null }); // Equipo y líder para el popup de bienvenida
    const [showLeaderPopup, setShowLeaderPopup] = useState(false); // Control del popup de liderazgo
    const hasShownLeaderPopupRef = useRef(false); // Ref para evitar mostrar el popup múltiples veces
    const isFirstLoadRef = useRef(true); // Ref para rastrear si es la primera carga de preguntas

    const opcionesIdioma = [
        {
          value: "es",
          label: (
            <div>
              <img
                src="/img/banderas/es.png"
                alt="ES"
                style={{ width: "20px", height: "15px", marginRight: "10px" }}
              />{" "}
              {t("spanish")}
            </div>
          ),
        },
        {
          value: "en",
          label: (
            <div>
              <img
                src="/img/banderas/en.png"
                alt="EN"
                style={{ width: "20px", height: "15px", marginRight: "10px" }}
              />{" "}
              {t("english")}
            </div>
          ),
        },
      ];
    
      const cambiarIdioma = (opcionSeleccionada) => {
        i18n.changeLanguage(opcionSeleccionada.value);
      };

      const fetchApiDataPost = async (url, executeRef, body) => {
        try {
            const apiUrl = process.env.REACT_APP_API_URL || "https://api.systemicsurvey.com";
            const response = await executeRef.current(`${apiUrl}${url}`, "POST", body);
    
            // Verifica que la respuesta tenga datos y retorna
            if (response) {
                return response; // Retorna la respuesta completa
            } else {
                console.error("Respuesta vacía o inesperada del API:", response);
                return null; // Retorna null si no hay datos
            }
        } catch (error) {
            console.error("Error en fetchApiDataPost:", error);
            return null; // Retorna null en caso de error
        }
    };
    

    // useEffect para inicialización (solo cuando hay token en la URL)
    useEffect(() => {
        const initializeSurvey = async () => {
        const queryParams = new URLSearchParams(location.search);
        const token = queryParams.get('token');
    
        if (token) {
            try {
                setSurveyToken(token);

                const resolveResponse = await fetchApiDataPost("/gestionEncuestas/resolveToken", executeRef, {
                    token,
                });

                const id_encuesta = resolveResponse?.data?.id_encuesta;
                const id_empleado = resolveResponse?.data?.id_empleado;

                if (!id_encuesta || !id_empleado) {
                    throw new Error(t('invalidToken'));
                }

                setSurveyWelcomeInfo({
                    nombreEquipo: resolveResponse?.data?.nombreEquipo ?? null,
                    nombreLider: resolveResponse?.data?.nombreLider ?? null,
                });
    
                // Resetear el flag del popup cuando se cambia de empleado
                hasShownLeaderPopupRef.current = false;
                setShowLeaderPopup(false);
                setManagerInfo(null);
                // Resetear el flag de primera carga cuando se cambia de empleado
                isFirstLoadRef.current = true;
                setShowAviso(true); // Resetear el aviso a visible para el nuevo empleado
    
                const verificarPolitica = async () => {
                    try {
                        const apiUrl = process.env.REACT_APP_API_URL || "https://api.systemicsurvey.com";
                        const response = await executeRef.current(
                            `${apiUrl}/auth/get-politica`,
                            "POST",
                            { id_empleado: id_empleado }
                        );                        
                        if (response?.data?.politicaAceptada) {
                            setPoliticaAceptada(true); // La política ya fue aceptada
                            
                        } else {
                            setPoliticaAceptada(false); // Mostrar la pantalla de aceptación
                        }
                    } catch (error) {
                        console.error("Error al verificar política:", error?.message ?? error);
                    } finally {
                        setLoading(false); // Finalizar el estado de carga
                    }
                };
    
                verificarPolitica();
    
                // Continuar con la lógica de obtención de preguntas (usar IDs resueltos del token)
                fetchApiDataPost("/gestionEncuestas/getPreguntas", executeRef, {
                    id_encuesta,
                    id_empleado,
                    idioma: i18n.language,
                });
                setIdEmpleado(id_empleado);
                setIdEncuesta(id_encuesta);
            } catch (error) {
                console.error('Error procesando token:', error?.message ?? error);
                setLoading(false); // En caso de error, detener el estado de carga
            }
        } else {
            setLoading(false); // Si no hay token, terminar el estado de carga
        }
        };

        initializeSurvey();
    }, [location.search]); // Solo depende de location.search, no de i18n.language

    // useEffect separado para recargar preguntas cuando cambia el idioma
    useEffect(() => {
        // Solo recargar preguntas si ya tenemos los IDs y la política está aceptada
        if (idEncuesta && idEmpleado && politicaAceptada && surveyToken) {
            fetchApiDataPost("/gestionEncuestas/getPreguntas", executeRef, {
                id_encuesta: idEncuesta,
                id_empleado: idEmpleado,
                idioma: i18n.language,
            });
        }
    }, [i18n.language, idEncuesta, idEmpleado, politicaAceptada, surveyToken]); // Solo se ejecuta cuando cambia el idioma
    

    useEffect(() => {
        executeRef.current = execute;
    }, [execute]);

    // Mantener el ref del historial actualizado
    useEffect(() => {
        questionHistoryRef.current = questionHistory;
    }, [questionHistory]);

    // Verificar periódicamente si la pregunta actual ya está respondida
    useEffect(() => {
        // Solo verificar si tenemos los datos necesarios y hay preguntas
        if (!idEncuesta || !idEmpleado || !politicaAceptada || preguntas.length === 0 || !surveyToken) {
            return;
        }

        // Verificar cada 3 segundos si la pregunta actual ya está respondida
        // PERO NO si estamos retrocediendo (navegando hacia atrás)
        const intervalId = setInterval(async () => {
            // No verificar si estamos retrocediendo
            if (isNavigatingBackRef.current) {
                return;
            }
            
            const currentQuestion = preguntas[currentQuestionIndex];
            if (currentQuestion && currentQuestion.id_pregunta) {
                // Recargar preguntas para verificar si la actual ya fue respondida
                await fetchApiDataPost("/gestionEncuestas/getPreguntas", executeRef, {
                    id_encuesta: idEncuesta,
                    id_empleado: idEmpleado,
                    idioma: i18n.language,
                });
                
                // La verificación se hará en el useEffect que procesa data
            }
        }, 30000); // Verificar cada 30 segundos

        return () => clearInterval(intervalId);
    }, [idEncuesta, idEmpleado, politicaAceptada, preguntas, currentQuestionIndex, i18n.language, surveyToken]);

    useEffect(() => {
        // Solo procesar si data existe y tiene la estructura esperada
        if (data && typeof data === 'object' && 'preguntasPorContestar' in data) {
            // Actualizar las preguntas respondidas si vienen en la respuesta
            if (data.preguntasRespondidas && Array.isArray(data.preguntasRespondidas)) {
                setPreguntasRespondidas(data.preguntasRespondidas);
            }
            
            // Verificar que preguntasPorContestar sea un array
            if (Array.isArray(data.preguntasPorContestar)) {
                if (data.preguntasPorContestar.length > 0) {
                    // Actualizar siempre las preguntas con la lista más reciente
                    setPreguntas(data.preguntasPorContestar);
                    
                    // Si tenemos un id_pregunta guardado, buscar su posición en el nuevo array
                    let newIndex = -1;
                    if (currentQuestionIdRef.current !== null) {
                        newIndex = data.preguntasPorContestar.findIndex(
                            p => p.id_pregunta === currentQuestionIdRef.current
                        );
                    }
                    
                    // Si la pregunta actual ya no está en la lista (fue respondida), mostrar mensaje y avanzar
                    // PERO solo si NO acabamos de enviar una respuesta nosotros mismos
                    // Y NO si estamos retrocediendo (navegando hacia atrás)
                    // Y NO si la pregunta está en el historial (significa que estamos retrocediendo a una pregunta ya respondida)
                    if (newIndex === -1 && currentQuestionIdRef.current !== null && !justSubmittedRef.current && !isNavigatingBackRef.current) {
                        // Verificar si la pregunta actual está en el historial usando el ref
                        const isInHistory = questionHistoryRef.current.some(q => q.id_pregunta === currentQuestionIdRef.current);
                        
                        // Solo activar la validación si NO está en el historial
                        if (!isInHistory) {
                            // La pregunta fue respondida desde otro dispositivo
                            setShowQuestionAlreadyAnswered(true);
                            // Avanzar a la primera pregunta pendiente después de 2 segundos
                            setTimeout(() => {
                                setShowQuestionAlreadyAnswered(false);
                                setCurrentQuestionIndex(0);
                                currentQuestionIndexRef.current = 0;
                                const newQuestionId = data.preguntasPorContestar[0]?.id_pregunta || null;
                                setCurrentQuestionId(newQuestionId);
                                currentQuestionIdRef.current = newQuestionId;
                                
                                // Agregar la nueva pregunta al historial si no está ya
                                if (newQuestionId) {
                                    setQuestionHistory(prev => {
                                        if (!prev.some(q => q.id_pregunta === newQuestionId)) {
                                            return [...prev, {
                                                id_pregunta: newQuestionId,
                                                tipo: data.preguntasPorContestar[0]?.tipo
                                            }];
                                        }
                                        return prev;
                                    });
                                }
                            }, 2000);
                        }
                    } else if (newIndex === -1 && currentQuestionIdRef.current !== null && justSubmittedRef.current) {
                        // Acabamos de enviar una respuesta, simplemente avanzar a la siguiente pregunta
                        justSubmittedRef.current = false; // Resetear el flag
                        if (data.preguntasPorContestar.length > 0) {
                            setCurrentQuestionIndex(0);
                            currentQuestionIndexRef.current = 0;
                            const newQuestionId = data.preguntasPorContestar[0]?.id_pregunta || null;
                            const newQuestionType = data.preguntasPorContestar[0]?.tipo || null;
                            setCurrentQuestionId(newQuestionId);
                            currentQuestionIdRef.current = newQuestionId;
                            
                            // Verificar si es la primera pregunta de liderazgo
                            if (newQuestionType === 'liderazgo' && data.managerInfo && !hasShownLeaderPopupRef.current && !isNavigatingBackRef.current) {
                                // Verificar si es la primera pregunta de liderazgo (no hay otras en el historial)
                                const liderazgoQuestionsInHistory = questionHistory.filter(q => q.tipo === 'liderazgo');
                                if (liderazgoQuestionsInHistory.length === 0) {
                                    setManagerInfo(data.managerInfo); // Asegurar que managerInfo esté en el estado
                                    setShowLeaderPopup(true);
                                    hasShownLeaderPopupRef.current = true;
                                }
                            }
                            
                            // Agregar la nueva pregunta al historial si no está ya
                            if (newQuestionId) {
                                setQuestionHistory(prev => {
                                    if (!prev.some(q => q.id_pregunta === newQuestionId)) {
                                        return [...prev, {
                                            id_pregunta: newQuestionId,
                                            tipo: newQuestionType
                                        }];
                                    }
                                    return prev;
                                });
                            }
                        } else {
                            setEncuestaCompletada(true);
                        }
                    } else if (newIndex !== -1) {
                        // Si encontramos la pregunta, actualizar el índice
                        justSubmittedRef.current = false; // Resetear el flag si encontramos la pregunta
                        
                        const newQuestionId = data.preguntasPorContestar[newIndex]?.id_pregunta || null;
                        const newQuestionType = data.preguntasPorContestar[newIndex]?.tipo || null;
                        
                        // Verificar si la pregunta encontrada está en el historial ANTES de actualizarlo
                        const isInHistory = questionHistory.some(q => q.id_pregunta === newQuestionId);
                        const isNewQuestion = !isInHistory;
                        
                        // Verificar si es la primera pregunta de liderazgo (solo si es nueva y no estamos retrocediendo)
                        if (isNewQuestion && newQuestionType === 'liderazgo' && data.managerInfo && !hasShownLeaderPopupRef.current && !isNavigatingBackRef.current) {
                            // Verificar si es la primera pregunta de liderazgo (no hay otras en el historial)
                            const liderazgoQuestionsInHistory = questionHistory.filter(q => q.tipo === 'liderazgo');
                            if (liderazgoQuestionsInHistory.length === 0) {
                                setManagerInfo(data.managerInfo); // Asegurar que managerInfo esté en el estado
                                setShowLeaderPopup(true);
                                hasShownLeaderPopupRef.current = true;
                            }
                        }
                        
                        // Verificar si la pregunta encontrada está en el historial
                        // Si no está, es una pregunta nueva, así que resetear el flag de navegación hacia atrás
                        setQuestionHistory(prev => {
                            if (!isInHistory) {
                                // Es una pregunta nueva, resetear el flag
                                isNavigatingBackRef.current = false;
                            }
                            // Agregar al historial si no está ya (evitar duplicados al recargar)
                            if (newQuestionId && !prev.some(q => q.id_pregunta === newQuestionId)) {
                                return [...prev, {
                                    id_pregunta: newQuestionId,
                                    tipo: newQuestionType
                                }];
                            }
                            return prev;
                        });
                        
                        setCurrentQuestionIndex(newIndex);
                        currentQuestionIndexRef.current = newIndex;
                        setCurrentQuestionId(newQuestionId);
                        currentQuestionIdRef.current = newQuestionId;
                    } else if (newIndex === -1 && currentQuestionIdRef.current !== null) {
                        // Si no encontramos la pregunta en las pendientes, verificar si está en el historial
                        // Si está en el historial, significa que estamos retrocediendo a una pregunta ya respondida
                        // En ese caso, mantener el flag activo para evitar la validación
                        const isInHistory = questionHistoryRef.current.some(q => q.id_pregunta === currentQuestionIdRef.current);
                        if (isInHistory) {
                            // Estamos retrocediendo a una pregunta del historial, mantener el flag activo
                            isNavigatingBackRef.current = true;
                        }
                    } else if (currentQuestionIdRef.current === null) {
                        // Si no hay pregunta previa, usar el índice actual si es válido
                        newIndex = currentQuestionIndexRef.current < data.preguntasPorContestar.length 
                            ? currentQuestionIndexRef.current 
                            : 0;
                        setCurrentQuestionIndex(newIndex);
                        currentQuestionIndexRef.current = newIndex;
                        const newQuestionId = data.preguntasPorContestar[newIndex]?.id_pregunta || null;
                        const newQuestionType = data.preguntasPorContestar[newIndex]?.tipo || null;
                        setCurrentQuestionId(newQuestionId);
                        currentQuestionIdRef.current = newQuestionId;
                        
                        // Si es la primera carga y la primera pregunta es de texto, ocultar el aviso
                        if (isFirstLoadRef.current && newQuestionType === 'texto') {
                            setShowAviso(false);
                            isFirstLoadRef.current = false;
                        } else if (isFirstLoadRef.current) {
                            isFirstLoadRef.current = false;
                        }
                        
                        // Verificar si es la primera pregunta de liderazgo
                        if (newQuestionType === 'liderazgo' && data.managerInfo && !hasShownLeaderPopupRef.current && !isNavigatingBackRef.current) {
                            // Verificar si es la primera pregunta de liderazgo (no hay otras en el historial)
                            const liderazgoQuestionsInHistory = questionHistory.filter(q => q.tipo === 'liderazgo');
                            if (liderazgoQuestionsInHistory.length === 0) {
                                setManagerInfo(data.managerInfo); // Asegurar que managerInfo esté en el estado
                                setShowLeaderPopup(true);
                                hasShownLeaderPopupRef.current = true;
                            }
                        }
                        
                        // Agregar al historial si no está ya
                        if (newQuestionId) {
                            setQuestionHistory(prev => {
                                if (!prev.some(q => q.id_pregunta === newQuestionId)) {
                                    return [...prev, {
                                        id_pregunta: newQuestionId,
                                        tipo: newQuestionType
                                    }];
                                }
                                return prev;
                            });
                        }
                    }
                setEncuestaCompletada(false); // Resetea el estado si hay preguntas pendientes
            } else {
                    // Solo marcar como completada si realmente no hay preguntas Y el array está vacío
                    setPreguntas([]);
                    setEncuestaCompletada(true);
                    setCurrentQuestionIndex(0);
                    currentQuestionIndexRef.current = 0;
                    setCurrentQuestionId(null);
                    currentQuestionIdRef.current = null;
                }
            }
            // Actualizar estado y total solo si existen en la respuesta
            if (data.estadoEncuesta !== undefined) {
            setEstadoEncuesta(data.estadoEncuesta);
            }
            if (data.totalPreguntas !== undefined) {
            setTotalPreguntas(data.totalPreguntas);
            }
            // Capturar información del manager si viene en la respuesta
            if (data.managerInfo !== undefined) {
                setManagerInfo(data.managerInfo);
            }
        }
        // Si data es null o no tiene la estructura esperada, no hacer nada
        // Esto evita que se actualice incorrectamente el estado cuando useFetch resetea data a null
    }, [data]);
    

    // useEffect para detectar cuando aparece la primera pregunta de liderazgo
    useEffect(() => {
        // Solo verificar si no hemos mostrado el popup aún
        if (hasShownLeaderPopupRef.current || showLeaderPopup) {
            return;
        }

        // Obtener la pregunta actual
        const currentQuestion = getCurrentQuestion();
        
        // Verificar si la pregunta actual es de tipo liderazgo
        if (currentQuestion && currentQuestion.tipo === 'liderazgo') {
            // Verificar si no estamos retrocediendo
            if (!isNavigatingBackRef.current) {
                // Verificar si es la primera pregunta de liderazgo
                // Buscar si hay preguntas de liderazgo en el historial que NO sean la actual
                const liderazgoQuestionsInHistory = questionHistory.filter(
                    q => q.tipo === 'liderazgo' && q.id_pregunta !== currentQuestion.id_pregunta
                );
                
                // Si no hay preguntas de liderazgo en el historial (excepto la actual), es la primera
                if (liderazgoQuestionsInHistory.length === 0) {
                    // Verificar que tenemos managerInfo antes de mostrar el popup
                    if (managerInfo) {
                        // Es la primera pregunta de liderazgo, mostrar el popup
                        setShowLeaderPopup(true);
                        hasShownLeaderPopupRef.current = true;
                    } else {
                        // Si no tenemos managerInfo aún, esperar a que se cargue
                    }
                }
            }
        }
    }, [currentQuestionId, preguntas, preguntasRespondidas, managerInfo, questionHistory]);

    // useEffect adicional para cuando managerInfo se establece después de detectar la pregunta de liderazgo
    useEffect(() => {
        // Solo verificar si managerInfo está disponible y no hemos mostrado el popup aún
        if (!managerInfo || hasShownLeaderPopupRef.current || showLeaderPopup) {
            return;
        }

        // Obtener la pregunta actual
        const currentQuestion = getCurrentQuestion();
        
        // Verificar si la pregunta actual es de tipo liderazgo
        if (currentQuestion && currentQuestion.tipo === 'liderazgo') {
            // Verificar si no estamos retrocediendo
            if (!isNavigatingBackRef.current) {
                // Verificar si es la primera pregunta de liderazgo
                // Buscar si hay preguntas de liderazgo en el historial que NO sean la actual
                const liderazgoQuestionsInHistory = questionHistory.filter(
                    q => q.tipo === 'liderazgo' && q.id_pregunta !== currentQuestion.id_pregunta
                );
                
                // Si no hay preguntas de liderazgo en el historial (excepto la actual), es la primera
                if (liderazgoQuestionsInHistory.length === 0) {
                    // Es la primera pregunta de liderazgo, mostrar el popup
                    setShowLeaderPopup(true);
                    hasShownLeaderPopupRef.current = true;
                }
            }
        }
    }, [managerInfo, currentQuestionId, preguntas, preguntasRespondidas, questionHistory]);

    useEffect(() => {
        const handleKeyDown = (event) => {
            // Si el popup de liderazgo está visible, cerrarlo con Enter
            if (showLeaderPopup && event.key === 'Enter') {
                handleCloseLeaderPopup();
                return;
            }
            
            const currentQuestion = getCurrentQuestion();
            if (currentQuestion && currentQuestion.tipo !== 'texto') {
                if (event.key >= '0' && event.key <= '4') {
                    setSelectedOption(parseInt(event.key));
                } else if (event.key === 'Enter') {
                    handleNextQuestion();
                }
            }
        };
        window.addEventListener('keydown', handleKeyDown);
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [selectedOption, currentQuestionId, preguntas, preguntasRespondidas, showLeaderPopup]);

    useEffect(() => {
        const checkIsMobile = () => setIsMobile(window.innerWidth <= 768);
        checkIsMobile();
        window.addEventListener('resize', checkIsMobile);
        return () => window.removeEventListener('resize', checkIsMobile);
    }, []);

    const handleNextQuestion = async (optionOverride = null) => {
        const currentQuestion = getCurrentQuestion();
        
        if (!currentQuestion) return;

        // Evitar múltiples envíos
        if (isSubmitting) return;

        // Verificar si la pregunta actual ya está respondida
        const preguntaRespondidaAnterior = preguntasRespondidas.find(p => p.id_pregunta === currentQuestion.id_pregunta);
        const isAnswered = preguntaRespondidaAnterior !== undefined;
        
        // Si la pregunta ya está respondida, verificar si la respuesta ha sido modificada
        if (isAnswered) {
            const optionToSend = optionOverride !== null ? optionOverride : selectedOption;
            let respuestaModificada = false;
            
            // Verificar si la respuesta ha cambiado
            if (currentQuestion.tipo === "texto") {
                // Para preguntas de texto, comparar el comentario
                const comentarioAnterior = preguntaRespondidaAnterior.comentario || '';
                const comentarioActual = textResponse || '';
                respuestaModificada = comentarioAnterior !== comentarioActual;
            } else {
                // Para preguntas de opciones, comparar la puntuación
                const puntuacionAnterior = preguntaRespondidaAnterior.puntuacion;
                const puntuacionActual = optionToSend;
                respuestaModificada = puntuacionAnterior !== puntuacionActual && puntuacionActual !== null;
            }
            
            // Si la respuesta ha sido modificada, enviarla al servidor antes de avanzar
            let preguntasRespondidasActualizadas = preguntasRespondidas;
            if (respuestaModificada && ((currentQuestion.tipo === "texto") || (currentQuestion.tipo !== "texto" && optionToSend !== null))) {
                setIsSubmitting(true);
                
                // Resetear el flag de navegación hacia atrás ya que estamos avanzando
                isNavigatingBackRef.current = false;
                
                // NO marcar justSubmittedRef como true porque queremos navegar manualmente
                // a la siguiente pregunta del historial, no a la primera pendiente
                
                // Enviar la respuesta modificada
                await fetchApiDataPost("/gestionEncuestas/postRespuesta", executeRef2, {
                    id_encuesta: idEncuesta,
                    id_empleado: idEmpleado,
                    id_pregunta: currentQuestion.id_pregunta,
                    puntuacion: currentQuestion.tipo !== "texto" ? optionToSend : null,
                    comentario: currentQuestion.tipo === "texto" ? textResponse : null,
                });
                
                // Recargar las preguntas para actualizar el estado con la nueva respuesta
                const response = await fetchApiDataPost("/gestionEncuestas/getPreguntas", executeRef, {
                    id_encuesta: idEncuesta,
                    id_empleado: idEmpleado,
                    idioma: i18n.language,
                });
                
                // Usar las preguntas respondidas actualizadas de la respuesta directa
                let preguntasActualizadas = preguntas;
                if (response && response.data) {
                    if (response.data.preguntasRespondidas && Array.isArray(response.data.preguntasRespondidas)) {
                        preguntasRespondidasActualizadas = response.data.preguntasRespondidas;
                        // Actualizar el estado local inmediatamente para que esté disponible al navegar
                        setPreguntasRespondidas(response.data.preguntasRespondidas);
                    }
                    if (response.data.preguntasPorContestar && Array.isArray(response.data.preguntasPorContestar)) {
                        preguntasActualizadas = response.data.preguntasPorContestar;
                        // Actualizar el estado local inmediatamente para que esté disponible al navegar
                        setPreguntas(response.data.preguntasPorContestar);
                    }
                }
                
                setIsSubmitting(false);
                
                // Buscar la posición actual en el historial
                const currentIndexInHistory = questionHistory.findIndex(
                    q => q.id_pregunta === currentQuestion.id_pregunta
                );
                
                // Si hay una siguiente pregunta en el historial, ir a ella
                if (currentIndexInHistory !== -1 && currentIndexInHistory < questionHistory.length - 1) {
                    const nextQuestionInHistory = questionHistory[currentIndexInHistory + 1];
                    
                    // Actualizar el currentQuestionIdRef INMEDIATAMENTE para que el useEffect no interfiera
                    currentQuestionIdRef.current = nextQuestionInHistory.id_pregunta;
                    setCurrentQuestionId(nextQuestionInHistory.id_pregunta);
                    
                    // Agregar la siguiente pregunta al historial si no está ya (por si acaso)
                    setQuestionHistory(prev => {
                        if (!prev.some(q => q.id_pregunta === nextQuestionInHistory.id_pregunta)) {
                            return [...prev, nextQuestionInHistory];
                        }
                        return prev;
                    });
                    
                    // Buscar si la siguiente pregunta está en las pendientes (usar las actualizadas)
                    const indexInPendientes = preguntasActualizadas.findIndex(
                        p => p.id_pregunta === nextQuestionInHistory.id_pregunta
                    );
                    
                    if (indexInPendientes !== -1) {
                        // La siguiente pregunta está en las pendientes
                        setCurrentQuestionIndex(indexInPendientes);
                        currentQuestionIndexRef.current = indexInPendientes;
                        setSelectedOption(null);
                        setTextResponse('');
                    } else {
                        // La siguiente pregunta está respondida
                        // Usar preguntasRespondidas actualizadas
                        const nextQuestionRespondida = preguntasRespondidasActualizadas.find(
                            p => p.id_pregunta === nextQuestionInHistory.id_pregunta
                        );
                        
                        if (nextQuestionRespondida) {
                            // Cargar la respuesta de la siguiente pregunta
                            if (nextQuestionRespondida.tipo === "texto") {
                                setTextResponse(nextQuestionRespondida.comentario || '');
                            } else {
                                setSelectedOption(nextQuestionRespondida.puntuacion);
                            }
                            setCurrentQuestionIndex(0);
                            currentQuestionIndexRef.current = 0;
                        }
                    }
                    
                    isNavigatingBackRef.current = false;
                    return;
                } else {
                    // No hay más preguntas en el historial, ir a la primera pendiente
                    if (preguntasActualizadas.length > 0) {
                        const newQuestionId = preguntasActualizadas[0]?.id_pregunta || null;
                        // Actualizar el currentQuestionIdRef INMEDIATAMENTE
                        currentQuestionIdRef.current = newQuestionId;
                        setCurrentQuestionId(newQuestionId);
                        setCurrentQuestionIndex(0);
                        currentQuestionIndexRef.current = 0;
                        setSelectedOption(null);
                        setTextResponse('');
                        isNavigatingBackRef.current = false;
                        return;
                    }
                }
            }
            
            // Si no se modificó la respuesta, buscar la siguiente pregunta en el historial normalmente
            // Buscar la posición actual en el historial
            const currentIndexInHistory = questionHistory.findIndex(
                q => q.id_pregunta === currentQuestion.id_pregunta
            );
            
            // Si hay una siguiente pregunta en el historial, ir a ella
            if (currentIndexInHistory !== -1 && currentIndexInHistory < questionHistory.length - 1) {
                const nextQuestionInHistory = questionHistory[currentIndexInHistory + 1];
                
                // Agregar la siguiente pregunta al historial si no está ya (por si acaso)
                setQuestionHistory(prev => {
                    if (!prev.some(q => q.id_pregunta === nextQuestionInHistory.id_pregunta)) {
                        return [...prev, nextQuestionInHistory];
                    }
                    return prev;
                });
                
                // Buscar si la siguiente pregunta está en las pendientes
                const indexInPendientes = preguntas.findIndex(
                    p => p.id_pregunta === nextQuestionInHistory.id_pregunta
                );
                
                if (indexInPendientes !== -1) {
                    // La siguiente pregunta está en las pendientes
                    setCurrentQuestionIndex(indexInPendientes);
                    currentQuestionIndexRef.current = indexInPendientes;
                    setSelectedOption(null);
                    setTextResponse('');
                } else {
                    // La siguiente pregunta está respondida
                    // Usar preguntasRespondidas actualizadas (de la respuesta directa si se modificó, o del estado si no)
                    const nextQuestionRespondida = preguntasRespondidasActualizadas.find(
                        p => p.id_pregunta === nextQuestionInHistory.id_pregunta
                    );
                    
                    if (nextQuestionRespondida) {
                        // Cargar la respuesta de la siguiente pregunta
                        if (nextQuestionRespondida.tipo === "texto") {
                            setTextResponse(nextQuestionRespondida.comentario || '');
                        } else {
                            setSelectedOption(nextQuestionRespondida.puntuacion);
                        }
                        setCurrentQuestionIndex(0);
                        currentQuestionIndexRef.current = 0;
                    }
                }
                
                setCurrentQuestionId(nextQuestionInHistory.id_pregunta);
                currentQuestionIdRef.current = nextQuestionInHistory.id_pregunta;
                isNavigatingBackRef.current = false;
                return;
            } else {
                // No hay más preguntas en el historial, ir a la primera pendiente
                if (preguntas.length > 0) {
                    setCurrentQuestionIndex(0);
                    currentQuestionIndexRef.current = 0;
                    const newQuestionId = preguntas[0]?.id_pregunta || null;
                    setCurrentQuestionId(newQuestionId);
                    currentQuestionIdRef.current = newQuestionId;
                    setSelectedOption(null);
                    setTextResponse('');
                    isNavigatingBackRef.current = false;
                    return;
                }
            }
        }

        // Si la pregunta no está respondida, enviar la respuesta y avanzar
        const optionToSend = optionOverride !== null ? optionOverride : selectedOption;

        if ((currentQuestion.tipo === "texto") || (currentQuestion.tipo !== "texto" && optionToSend !== null)) {
            setIsSubmitting(true); // Bloquear interacciones durante el envío
            
            // Resetear el flag de navegación hacia atrás ya que estamos avanzando
            isNavigatingBackRef.current = false;
            
            // Agregar la pregunta actual al historial antes de avanzar (si no está ya)
            const currentQuestionData = {
                id_pregunta: currentQuestion.id_pregunta,
                tipo: currentQuestion.tipo
            };
            setQuestionHistory(prev => {
                if (!prev.some(q => q.id_pregunta === currentQuestion.id_pregunta)) {
                    return [...prev, currentQuestionData];
                }
                return prev;
            });
            
            // Marcar que acabamos de enviar una respuesta
            justSubmittedRef.current = true;
            
            await fetchApiDataPost("/gestionEncuestas/postRespuesta", executeRef2, {
                id_encuesta: idEncuesta,
                id_empleado: idEmpleado,
                id_pregunta: currentQuestion.id_pregunta,
                puntuacion: currentQuestion.tipo !== "texto" ? optionToSend : null,
                comentario: currentQuestion.tipo === "texto" ? textResponse : null,
            });
            setSelectedOption(null);
            setTextResponse("");
            if (showAviso) {
                handleHideAviso(); // Ocultar aviso inicial si aplica
            }
            
            // Recargar las preguntas pendientes para sincronizar el estado
            await fetchApiDataPost("/gestionEncuestas/getPreguntas", executeRef, {
                id_encuesta: idEncuesta,
                id_empleado: idEmpleado,
                idioma: i18n.language,
            });
            
            setIsSubmitting(false); // Permitir nuevas interacciones
        }
    };
    
    // Maneja la animación de salida del aviso
    const handleHideAviso = () => {
        setHideAviso(true);
        setTimeout(() => {
            setShowAviso(false);
        }, 500); // Duración de la animación de salida
    };

    // Maneja el cierre del popup de liderazgo
    const handleCloseLeaderPopup = () => {
        setShowLeaderPopup(false);
    };

    const handlePreviousQuestion = () => {
        // Marcar que estamos retrocediendo para desactivar la validación
        isNavigatingBackRef.current = true;
        
        // Si hay historial y no estamos en la primera pregunta del historial
        if (questionHistory.length > 1) {
            // Buscar la posición actual en el historial
            const currentIndexInHistory = questionHistory.findIndex(
                q => q.id_pregunta === currentQuestionId
            );
            
            // Si encontramos la posición y no es la primera, retroceder
            if (currentIndexInHistory > 0) {
                const previousQuestion = questionHistory[currentIndexInHistory - 1];
                
                if (previousQuestion) {
                    // No remover del historial, solo cambiar la pregunta actual
                
                // Buscar si la pregunta anterior está en las preguntas pendientes
                const indexInPendientes = preguntas.findIndex(
                    p => p.id_pregunta === previousQuestion.id_pregunta
                );
                
                if (indexInPendientes !== -1) {
                    // La pregunta está en las pendientes, usar ese índice
                    setCurrentQuestionIndex(indexInPendientes);
                    currentQuestionIndexRef.current = indexInPendientes;
                    setSelectedOption(null);
                    setTextResponse('');
                } else {
                    // La pregunta ya fue respondida, buscar en preguntasRespondidas
                    const preguntaRespondida = preguntasRespondidas.find(
                        p => p.id_pregunta === previousQuestion.id_pregunta
                    );
                    
                    if (preguntaRespondida) {
                        // Cargar la respuesta anterior
                        if (preguntaRespondida.tipo === "texto") {
                            setTextResponse(preguntaRespondida.comentario || '');
                        } else {
                            setSelectedOption(preguntaRespondida.puntuacion);
                        }
                    } else {
                        // Si no se encuentra, limpiar las respuestas
                        setSelectedOption(null);
                        setTextResponse('');
                    }
                    
                    // Mantener el índice en 0 pero actualizar el ID
                    // Esto permite mantener la verificación de ID de pregunta
                    setCurrentQuestionIndex(0);
                    currentQuestionIndexRef.current = 0;
                }
                
                setCurrentQuestionId(previousQuestion.id_pregunta);
                currentQuestionIdRef.current = previousQuestion.id_pregunta;
                }
            } else {
                // Si estamos en la primera pregunta del historial, no hacer nada
                // O podríamos permitir retroceder más si hay más preguntas respondidas
            }
        } else if (currentQuestionIndex > 0) {
            // Fallback: si no hay historial suficiente, usar la lógica anterior
            const prevIndex = currentQuestionIndex - 1;
            setCurrentQuestionIndex(prevIndex);
            currentQuestionIndexRef.current = prevIndex;
            const prevQuestionId = preguntas[prevIndex]?.id_pregunta || null;
            setCurrentQuestionId(prevQuestionId);
            currentQuestionIdRef.current = prevQuestionId;
            setSelectedOption(null);
            setTextResponse('');
        }
        
        // Resetear el flag después de un tiempo para permitir validaciones futuras
        // Usamos 5 segundos para asegurarnos de que cubra el intervalo de verificación (3 segundos)
        setTimeout(() => {
            isNavigatingBackRef.current = false;
        }, 5000); // 5 segundos para asegurar que cubra el intervalo de verificación
    };

    // Función para obtener la pregunta actual (de pendientes o respondidas)
    const getCurrentQuestion = () => {
        if (!currentQuestionId) return null;
        
        // Buscar primero en las preguntas pendientes
        const preguntaPendiente = preguntas.find(p => p.id_pregunta === currentQuestionId);
        if (preguntaPendiente) {
            return preguntaPendiente;
        }
        
        // Si no está en pendientes, buscar en respondidas
        const preguntaRespondida = preguntasRespondidas.find(p => p.id_pregunta === currentQuestionId);
        if (preguntaRespondida) {
            return preguntaRespondida;
        }
        
        // Si no se encuentra, usar la pregunta del índice actual como fallback
        return preguntas[currentQuestionIndex] || null;
    };

    // Función para formatear la pregunta con palabras en negrita según el tipo
    const formatQuestion = (questionText, questionType) => {
        if (!questionText) return '';
        
        // Determinar qué palabras poner en negrita según el tipo de pregunta
        let wordsToBold = [];
        
        if (questionType === 'personal') {
            // Solo "Yo" y variantes en español e inglés
            wordsToBold = ['Yo', 'yo', 'I', 'i'];
        } else if (questionType === 'equipo') {
            // Solo "Equipo" y variantes en español e inglés
            wordsToBold = ['equipo', 'Equipo', 'team', 'Team'];
        } else if (questionType === 'liderazgo') {
            // Solo "Lider" y variantes en español e inglés
            wordsToBold = ['líder', 'Líder', 'leader', 'Leader'];
        }
        
        let formattedText = questionText;
        
        // Crear una expresión regular que coincida con las palabras completas
        wordsToBold.forEach(word => {
            const regex = new RegExp(`\\b${word.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}\\b`, 'gi');
            formattedText = formattedText.replace(regex, (match) => `<strong>${match}</strong>`);
        });
        
        return formattedText;
    };

    const handleAceptarPolitica = async () => {
        try {
            await fetchApiDataPost("/auth/aceptar-politica", executeRef, {
                id_empleado: idEmpleado,
                versionPolitica: "1.0", // Ajustar dinámicamente si es necesario
            });
    
            setPoliticaAceptada(true); // Marca políticas como aceptadas
    
            // Recargar preguntas tras aceptar políticas
            const response = await fetchApiDataPost("/gestionEncuestas/getPreguntas", executeRef, {
                id_encuesta: idEncuesta,
                id_empleado: idEmpleado,
                idioma: i18n.language,
            });
    
            if (response && response.data && response.data.preguntasPorContestar) {
                const nuevasPreguntas = response.data.preguntasPorContestar;
                setPreguntas(nuevasPreguntas);
                setEncuestaCompletada(false); // Resetea el estado si hay preguntas pendientes
                // Sincronizar refs y estado: resetear a la primera pregunta (índice 0)
                setCurrentQuestionIndex(0);
                currentQuestionIndexRef.current = 0;
                const primeraPreguntaId = nuevasPreguntas.length > 0 ? nuevasPreguntas[0].id_pregunta : null;
                const primeraPreguntaTipo = nuevasPreguntas.length > 0 ? nuevasPreguntas[0]?.tipo : null;
                setCurrentQuestionId(primeraPreguntaId);
                currentQuestionIdRef.current = primeraPreguntaId;
                
                // Si es la primera carga y la primera pregunta es de texto, ocultar el aviso
                if (isFirstLoadRef.current && primeraPreguntaTipo === 'texto') {
                    setShowAviso(false);
                    isFirstLoadRef.current = false;
                } else if (isFirstLoadRef.current) {
                    isFirstLoadRef.current = false;
                }
                
                // Verificar si es la primera pregunta de liderazgo
                if (primeraPreguntaTipo === 'liderazgo' && response.data.managerInfo && !hasShownLeaderPopupRef.current) {
                    setShowLeaderPopup(true);
                    hasShownLeaderPopupRef.current = true;
                    setManagerInfo(response.data.managerInfo);
                }
                
                // Inicializar el historial con la primera pregunta
                if (primeraPreguntaId) {
                    setQuestionHistory([{
                        id_pregunta: primeraPreguntaId,
                        tipo: primeraPreguntaTipo
                    }]);
                }
                
                // Actualizar estado y total si existen en la respuesta
                if (response.data.estadoEncuesta !== undefined) {
                    setEstadoEncuesta(response.data.estadoEncuesta);
                }
                if (response.data.totalPreguntas !== undefined) {
                    setTotalPreguntas(response.data.totalPreguntas);
                }
            } else {
                console.error("Estructura inesperada en la respuesta al cargar preguntas:", response);
                setPreguntas([]); // Asegúrate de que no queden preguntas
                setEncuestaCompletada(true); // Marca encuesta como completada si no hay preguntas
                // Sincronizar refs cuando no hay preguntas
                setCurrentQuestionIndex(0);
                currentQuestionIndexRef.current = 0;
                setCurrentQuestionId(null);
                currentQuestionIdRef.current = null;
            }
        } catch (error) {
            console.error("Error al aceptar la política:", error?.message ?? error);
        }
    };
    
    
    

    return (
        <div className={styles.allSurvey}>
            {loading ? (
                <Loader />
            ) : (
                <>
                    <div className={styles.sidebarSurvey}>
                        <img className={styles.logoi8} src="/img/systemic horizontal.svg" alt="Instituto Logo" />
                        <div className={styles.logofeel}>
                            <img className={styles.logoInstitutoImg} src="/img/logoInstituto8color.png" alt="Logo Instituto 8" />
                            <p>Powered by</p>
                            <img className={styles.logoLogin} src="/img/logo_largo.png" alt="Suto Studio Logo" />
                        </div>
                    </div>
                    <div className={styles.encuestaContainer}>
                        {/* Selector de idioma siempre visible */}
                        <div className={styles.changeLanguage}>
                            <Select
                                options={opcionesIdioma}
                                placeholder={t("changeLanguage")}
                                menuPlacement="top"
                                onChange={cambiarIdioma}
                                value={opcionesIdioma.find(
                                    (opcion) => opcion.value === i18n.language
                                )}
                            />
                        </div>
                        {/* Pantalla para aceptar la política o mostrar la encuesta */}
                        {!politicaAceptada ? (
                            <div className={styles.encuestaCardPrivacidad}>
                                <h2>{t("welcomeToSurvey")}</h2>
                                <p>{t("thankYouForYourTime")}</p>
                                {surveyWelcomeInfo.nombreEquipo && (
                                    <p>
                                        {surveyWelcomeInfo.nombreLider ? (
                                            <>
                                                {t("surveyWelcomeTeamLeaderBefore")}
                                                <span className={styles.surveyWelcomeHighlight}>{surveyWelcomeInfo.nombreEquipo}</span>
                                                {t("surveyWelcomeTeamLeaderMiddle")}
                                                <span className={styles.surveyWelcomeHighlight}>{surveyWelcomeInfo.nombreLider}</span>
                                                {t("surveyWelcomeTeamLeaderAfter")}
                                            </>
                                        ) : (
                                            <>
                                                {t("surveyWelcomeTeamOnlyBefore")}
                                                <span className={styles.surveyWelcomeHighlight}>{surveyWelcomeInfo.nombreEquipo}</span>
                                                {t("surveyWelcomeTeamOnlyAfter")}
                                            </>
                                        )}
                                    </p>
                                )}
                                <p>{t("checkandconfirm")}</p>
                                <div className={styles.politicaCheck}>
                                    <div className={styles.checkboxContainer}>
                                        <input
                                            type="checkbox"
                                            id="ambienteTranquilo"
                                            onChange={(e) => setAmbienteTranquilo(e.target.checked)}
                                        />
                                        <label htmlFor="ambienteTranquilo">
                                            {t("quietEnvironment")}
                                            <p className={styles.estimatedtime}>{t("estimatedTime")}</p>
                                        </label>
                                    </div>
                                    <div className={styles.checkboxContainer}>
                                        <input
                                            type="checkbox"
                                            id="aceptaPolitica"
                                            onChange={(e) => setAceptaPolitica(e.target.checked)}
                                        />
                                        <label htmlFor="aceptaPolitica">
                                            {t("agreeToTerms")}{" "}
                                            <a
                                                href="/politica-privacidad"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                {t("privacyPolicy")}
                                            </a>
                                            .
                                        </label>
                                    </div>
                                    <p className={styles.usarBotones}>{t("usarBotones")}</p>
                                </div>
                                <button
                                    className={styles.botonPrivacidad}
                                    onClick={handleAceptarPolitica}
                                    disabled={!ambienteTranquilo || !aceptaPolitica}
                                >
                                    {t("accept")}
                                </button>
                                <div className={styles.abajoIzquierda}>
                                    <p>{t("soporteTecnico")}</p>
                                    <p>{t("derechosReservados")}</p>
                                </div>
                            </div>
                        ) : (
                            <>
                                {encuestaCompletada && (
                                    <Confetti recycle={false} numberOfPieces={500} gravity={0.5} />
                                )}
                                {/* Aviso de teclado */}
                                {showAviso && estadoEncuesta !== "finalizada" && (
                                    <div className={`${styles.aviso} ${hideAviso ? styles.hide : ""}`}>
                                        <div className={styles.paddingAviso}>
                                            <p>{t("reminderKeyboard")}</p>
                                            <div className={styles.pulsadoresinfo}>
                                                <span>0</span> <span>1</span> <span>2</span> <span>3</span> <span>4</span> <span>{t("pulseEnter")}</span>
                                            </div>
                                        </div>
                                    </div>
                                )}

                                {/* Aviso de pregunta ya respondida */}
                                {showQuestionAlreadyAnswered && (
                                    <div className={styles.aviso}>
                                        <div className={styles.paddingAviso}>
                                            <p>{t("questionAlreadyAnswered")}</p>
                                        </div>
                                    </div>
                                )}

                                {/* Popup de liderazgo */}
                                {showLeaderPopup && managerInfo && (
                                    <div className={styles.managerPopupOverlay}>
                                        <div className={styles.managerPopup}>
                                            <h3>{t("evaluatingLeader")}</h3>
                                            <div className={styles.managerName}>
                                                {managerInfo.nombre} {managerInfo.apellido}
                                            </div>
                                            <div className={styles.managerPopupButtonContainer}>
                                                <button
                                                    className={styles.boton}
                                                    onClick={handleCloseLeaderPopup}
                                                >
                                                    {t("continue")}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                )}
    
                                {/* Pantallas según el estado de la encuesta */}
                                {estadoEncuesta === "finalizada" ? (
                                    <div className={styles.encuestaCard}>
                                        <h2>{t("surveyFinished")}</h2>
                                        <p>{t("cannotAnswer")}</p>
                                    </div>
                                ) : encuestaCompletada ? (
                                    <div className={`${styles.encuestaCard} ${styles.encuestaCardCompletada}`}>
                                        <h2>{t("thanksForAnswer")}</h2>
                                        <p>{t("participationIsImportant")}</p>
                                    </div>
                                ) : (preguntas.length > 0 || getCurrentQuestion()) ? (
                                    (() => {
                                        const currentQuestion = getCurrentQuestion();
                                        if (!currentQuestion) return null;
                                        
                                        // Calcular el progreso basándose en si la pregunta está respondida o no
                                        const preguntaRespondida = preguntasRespondidas.find(p => p.id_pregunta === currentQuestion.id_pregunta);
                                        const preguntasRespondidasCount = preguntasRespondidas.length;
                                        const preguntasPendientesCount = preguntas.length;
                                        const preguntaIndex = preguntaRespondida 
                                            ? preguntasRespondidas.findIndex(p => p.id_pregunta === currentQuestion.id_pregunta) + 1
                                            : preguntasPendientesCount > 0 
                                                ? preguntas.findIndex(p => p.id_pregunta === currentQuestion.id_pregunta) + 1 + preguntasRespondidasCount
                                                : preguntasRespondidasCount + 1;
                                        
                                        return (
                                    <div className={styles.encuestaCard}>
                                        <div className={styles.encuestaProgressText}>
                                            {preguntaIndex}/{totalPreguntas}
                                        </div>
                                        <div className={styles.encuestaProgress}>
                                            <div
                                                className={styles.encuestaProgressBar}
                                                style={{
                                                    width: `${(preguntaIndex / totalPreguntas) * 100}%`,
                                                }}
                                            ></div>
                                        </div>
                                        <div className={styles.encuestaContent}>
                                            <div className={styles.tipoPregunta}>
                                                <img 
                                                    src={
                                                        currentQuestion.tipo === "personal" 
                                                            ? "/img/logopersona.png" 
                                                            : currentQuestion.tipo === "liderazgo"
                                                            ? "/img/logolider.png"
                                                            : "/img/logoequipo.png"
                                                    } 
                                                    alt={
                                                        currentQuestion.tipo === "personal" 
                                                            ? t("personal") 
                                                            : currentQuestion.tipo === "liderazgo"
                                                            ? t("liderazgo")
                                                            : t("equipo")
                                                    }
                                                    className={styles.tipoPreguntaImg}
                                                />
                                            </div>
                                            <div 
                                                className={styles.pregunta}
                                                dangerouslySetInnerHTML={{ 
                                                    __html: formatQuestion(currentQuestion.pregunta, currentQuestion.tipo) 
                                                }}
                                            />
                                            {currentQuestion.tipo === "texto" ? (
                                                <textarea
                                                    className={styles.textArea}
                                                    value={textResponse}
                                                    onChange={(e) => setTextResponse(e.target.value)}
                                                    placeholder={t("writeYourAnswer")}
                                                ></textarea>
                                            ) : (
                                                <>
                                                {isMobile ? (
                                                    <div className={styles.mobileOptions}>
                                                        {[t("always"), t("often"), t("sometimes"), t("rarely"), t("never")].map((label, idx) => {
                                                            // Mapear el índice visual (invertido) al índice real (0-4)
                                                            const realIdx = 4 - idx;
                                                            return (
                                                                <button
                                                                    key={label}
                                                                    className={`${styles.mobileOptionButton} ${selectedOption === realIdx ? styles.mobileOptionSelected : ""}`}
                                                                    onClick={() => {
                                                                        setSelectedOption(realIdx);
                                                                        handleNextQuestion(realIdx);
                                                                    }}
                                                                    disabled={isSubmitting}
                                                                >
                                                                    {label}
                                                                </button>
                                                            );
                                                        })}
                                                    </div>
                                                ) : (
                                                    <div className={styles.opciones}>
                                                        {[t("never"), t("rarely"), t("sometimes"), t("often"), t("always")].map((label, idx) => (
                                                            <div className={styles.opcionColumn} key={label}>
                                                                <div
                                                                    className={`${styles.opcion} ${selectedOption === idx ? styles.selected : ""}`}
                                                                    onClick={() => setSelectedOption(idx)}
                                                                >
                                                                    <div className={styles.circle}></div>
                                                                </div>
                                                                <span className={styles.labelPunto}>{label}</span>
                                                            </div>
                                                        ))}
                                                    </div>
                                                )}
                                                </>
                                            )}
                                        </div>
                                        <div
                                            className={styles.botonContainer}
                                            style={
                                                isMobile && currentQuestion.tipo !== "texto"
                                                    ? { justifyContent: "center" }
                                                    : undefined
                                            }
                                        >
                                            <button
                                                className={`${styles.boton} ${styles.botonAnterior} ${isMobile ? styles.botonAnteriorMobile : ""}`}
                                                onClick={handlePreviousQuestion}
                                                style={{
                                                    visibility: questionHistory.length > 1 ? "visible" : "hidden",
                                                }}
                                            >
                                                {isMobile ? "←" : t("previous")}
                                            </button>
                                            {!(isMobile && currentQuestion.tipo !== "texto") && (
                                                <button
                                                    className={`${styles.boton} ${
                                                        selectedOption === null &&
                                                        currentQuestion.tipo !== "texto"
                                                            ? styles.disabled
                                                            : ""
                                                    } ${isSubmitting ? styles.submitting : ""}`}
                                                    onClick={() => handleNextQuestion()}
                                                    disabled={
                                                        (selectedOption === null &&
                                                            currentQuestion.tipo !== "texto") ||
                                                        isSubmitting
                                                    }
                                                >
                                                    {preguntas.length === 0 || currentQuestionIndex === preguntas.length - 1
                                                        ? t("finish")
                                                        : t("next")}
                                                </button>
                                            )}
                                        </div>
                                    </div>
                                        );
                                    })()
                                ) : (
                                    <Loader />
                                )}
                            </>
                        )}
                    </div>
    
                    <div className={styles.cuchiliuau}>
                        <img className={styles.logoi8Mobile} src="/img/systemic horizontal.svg" alt="Instituto Logo" />
                        <div className={styles.logofeelMobile}>
                            <img className={styles.logoInstitutoImgMobile} src="/img/logoInstituto8color.png" alt="Logo Instituto 8" />
                            <p>Powered by</p>
                            <img
                                className={styles.logoLoginMobile}
                                src="/img/logo_largo.png"
                                alt="Suto Studio Logo"
                            />
                        </div>
                    </div>
                </>
            )}
        </div>
    );
    
    

}
export default Encuesta;
